var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdatePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.712 14.8155L12 17.4866H9.6V19.8505H7.2V22.2144L4.8 24.5783H0V19.8505L9.912 10.0877C9.44607 8.57479 9.50677 6.95191 10.0845 5.47687C10.6621 4.00182 11.7237 2.75921 13.1005 1.94643C14.4773 1.13365 16.0903 0.797312 17.6834 0.990845C19.2764 1.18438 20.7582 1.89668 21.8932 3.01461C23.0282 4.13253 23.7513 5.59196 23.9478 7.16105C24.1443 8.73014 23.8028 10.3189 22.9776 11.675C22.1525 13.031 20.8909 14.0766 19.3933 14.6456C17.8957 15.2146 16.248 15.2744 14.712 14.8155ZM20.544 9.35489C21.0468 8.85901 21.3892 8.22749 21.5278 7.54007C21.6665 6.85266 21.5952 6.1402 21.323 5.49267C21.0508 4.84514 20.5898 4.29159 19.9984 3.90192C19.407 3.51226 18.7116 3.30397 18 3.30335C17.0455 3.30418 16.1305 3.6783 15.456 4.34346L20.544 9.35489Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatePassword);
export default __webpack_public_path__ + "static/media/update-password.7f05abf3bb33a3693ee2d17896bfa722.svg";
export { ForwardRef as ReactComponent };